import React from 'react'
import './TrainingStyles.css'

import { Link } from 'react-router-dom'

import Pod from '../assets/poda.jpg'
import Moon from '../assets/podb.jpg'
import Pod2 from '../assets/moona.jpg'
import Moon2 from '../assets/moonb.jpg'

const Exhibit = () => {
    return (
        <div className='training'>
            <div className='left'>
                <h1>Sponsorship Opportunities</h1>
                <p>Become a sponsor of the Africa Mining Summit Investment and gain unparalleled exposure to the continent's most influential mining professionals. Network with industry leaders, showcase your brand, and drive business growth.</p>
                <Link to='/contact'><button className='btn'>Register Now</button></Link>
            </div>
            <div className='right'>
                <div className='img-container'>
                    <div className='image-stack top'>
                        <img src={Moon} className='img' alt='' />
                    </div>
                    <div className='image-stack bottom'>
                        <img src={Pod} className='img' alt='' />
                    </div>
                </div>
            </div>
            <div className='t_right'>
                <div className='img-container'>
                    <div className='image-stack top'>
                        <img src={Moon2} className='img' alt='' />
                    </div>
                    <div className='image-stack bottom'>
                        <img src={Pod2} className='img' alt='' />
                    </div>
                </div>
            </div>
            <div className='t_left'>
                <h1>Become an Exhibitor</h1>
                <p>Join us as an exhibitor at the Africa Mining Summit Investment and showcase your products and services to a targeted audience of industry professionals. Network with potential clients, partners, and investors, and expand your business reach in the African mining market.</p>
            </div>
        </div>
    )
}

export default Exhibit
